import React from 'react';
import Picture from '../../images/banner.png'
import FocusButton from '../Shared/FocusButton';

const Banner = () => {
    return (
        <div>
           <div class="hero min-h-screen">
  <div class="hero-content flex-col lg:flex-row-reverse px-12">
    <img src={Picture} class="max-w-sm rounded-lg shadow-2xl" />
    <div className='lg:pr-12'>
      <h1 class="text-5xl font-bold">Faisal Karim</h1>
      <p class="py-6 text-yellow-500 font-bold">Jr. Web-Developer</p>
      <FocusButton>
        <a href="https://drive.google.com/file/d/1wb47FF1JyXgDJGgdYIEWt-v-u-_OcAFJ/view?usp=sharing">Download Resume</a>
      </FocusButton>
    </div>
  </div>
</div>
        </div>
    );
};

export default Banner;